import { lazy } from 'react';

export const CoursesPage = lazy(() => import('./CoursesPage'));
